<style lang="less" scoped>
  @baseFontSize: 1vh;

  .login{
    width: 100%;
    height: 100%;
    position: absolute;
    background: url("../assets/images/login/face-min.png") no-repeat 5vw center;
    background-size: 50vw auto;
    .login-box{
      width: @baseFontSize * 60;
      min-width: 40vw;
      height: 80%;
      position: absolute;
      right: @baseFontSize * 3;
      bottom: 0;
    }
    .login-title{
      width: 100%;
      text-align: center;
      margin: 0;
      font-size: @baseFontSize * 4;
      letter-spacing: 5px;
      font-family: "SourceHanSansCN-Regular", "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
      background-image: linear-gradient(#35CDFF, #84FAFF);
      -webkit-background-clip: text; /*必需加前缀 -webkit- 才支持这个text值 */
      -webkit-text-fill-color: transparent; /*text-fill-color会覆盖color所定义的字体颜色： */
    }
    .login-subtitle{
      width: 100%;
      text-align: center;
      font-size: @baseFontSize * 2.2;
      letter-spacing: 2px;
      font-weight: normal;
      color: #24A6CF;
      margin: 5px 0;
      text-transform: uppercase;
      font-family: "SourceHanSansCN-Regular", "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
    }
    .login-form{
      height: @baseFontSize * 40;
      width: @baseFontSize * 60;
      margin: 5% auto;
      background-color: rgba(66, 189, 255, .1);
      position: relative;

      &::before{
        display: block;
        position: absolute;
        content: "";
        width: 100%;
        height: 100%;
        background: url("../assets/images/login/corner.png") top left no-repeat,
        url("../assets/images/login/corner2.png") top right no-repeat,
        url("../assets/images/login/corner3.png") bottom left no-repeat,
        url("../assets/images/login/corner4.png") bottom right no-repeat;
      }

      /deep/.el-form{
        padding: @baseFontSize*40/7 @baseFontSize*40/7;
        font-size: @baseFontSize * 5!important;
        height: @baseFontSize*40/7*4;
        .el-form-item{
          height: @baseFontSize*40/7 !important;
          &:not(:last-child){
            margin-bottom: @baseFontSize*40/7!important;
          }
          .el-form-item__label{
            position: absolute;
            margin-left: 20px;
            z-index: 5;
            color: #11ABDA;
            letter-spacing: 2px;
            font-size: @baseFontSize*2.5!important;
            line-height: @baseFontSize*40/7 !important;
            width: @baseFontSize*12!important;
            text-align:justify;
            text-justify:distribute-all-lines;/*ie6-8*/
            text-align-last:justify;/* ie9*/
            -moz-text-align-last:justify;/*ff*/
            -webkit-text-align-last:justify;/*chrome 20+*/
            &::before{display: none;}
          }
          .el-form-item__content{
            font-size: @baseFontSize*2.5!important;
            height: 100%;
            margin-left: 0px!important;
            .el-input{
              height: 100%;
              .el-icon-view{
                font-size: 22px;
                color: #ddd;
              }
              .el-input__inner{
                height: 100%;
                background-color: #0c1427;
                border: 1px solid rgba(255, 255, 255, 0.1);
                border-radius: 0;
                padding-left: calc(@baseFontSize*12 + 20px);
                font-size: @baseFontSize*2.5!important;
                color: #ddd;
                &:focus{
                  border: 1px solid rgba(255, 255, 255, 0.3);
                }
              }
            }
          }
          &:last-child{
            .el-form-item__content{
              margin-left: 0!important;
              text-align: center;
              width: 100%;
              display: flex;
              .el-button{
                border-radius: 0;
                background:linear-gradient(0deg,rgba(53,205,255,.3),rgba(100,217,255,.3));
                border: 0;
                span{
                  font-size: @baseFontSize*2.5!important;
                  display: block;
                  letter-spacing: 10px;
                  margin-right: -10px;
                }
                &:last-child{
                  flex: 1;
                  background-color: #65a0b3;
                }
              }
            }
          }
        }

      }
    }
  }
</style>

<template>
  <div class="login">
    <div class="login-box">
      <h1 class="login-title">人脸识别系统</h1>
      <h3 class="login-subtitle">face recognization system</h3>
      <div class="login-form" @keydown.enter="submit">

        <check-and-qrcode :checkOk="checkOk" v-if="!ok && needCheck"></check-and-qrcode>

        <el-form ref="form" v-else :model="form">
          <el-form-item label="用户名" prop="username">
            <el-input v-model="form.username"></el-input>
          </el-form-item>
          <el-form-item label="密码" prop="password">
            <el-input v-model="form.password" type="password"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button v-if="directSupport" @click="$router.push('/1vs1/detect')" style="flex:2; color: white;">直接使用</el-button>
            <el-button type="primary" @click="submit">登录</el-button>
          </el-form-item>
        </el-form>

      </div>
    </div>
  </div>
</template>

<script>
  import { mapActions } from "vuex";
  import { rules } from "@/utils";
  import config from '../config';
  import checkAndQrcode from "@/components/checkAndQrcode";

  export default {
    components: {
      checkAndQrcode
    },
    data() {
      return {
        form: {
          username: "",
          password: ""
        },
        rules: {
          username: [rules.required()],
          password: [rules.required()]
        },
        ok: false
      };
    },
    watch: {
      ok(v){
        console.log(v)
      }
    },
    computed: {
      needCheck(){
        console.log(config.check_control)
        return config.check_control
      },
      directSupport(){
        return config.direct_support
      }
    },
    methods: {
      ...mapActions(["login"]),
      checkOk(){
        this.ok = true
      },
      async submit() {
        let ok = await this.$refs.form.validate();
        if (!ok) {
          return;
        }

        try {
          await this.login(this.form);
        } catch ({ response }) {
          if (response.status !== 400) {
            return;
          }
          this.$message("用户名密码错误");
        }
      }
    }
  };
</script>

